import React, {Component} from 'react';
import {connect} from 'react-redux'
import {
    Field,
    reduxForm,
} from 'redux-form'
import {locale} from '../../locale/AppLocale'
import Loader from "../../Components/Loader";
import axios from 'axios';
import {NotificationManager} from '../../Helpers/NotificationManager';;
import isEmpty from 'validator/lib/isEmpty';
import trim from 'validator/lib/trim';
import ProductInput from "../../Components/ProductInput";
import Config from "../../Helpers/Config";
import FinancialBankDetailsPopUp from "../../Components/FinancialBankDetailsPopUp";
import {FormattedPrice} from "../../Helpers/FormattedPrice";
import ShooqModal from '../../Components/ShooqModal';

class AccountSummary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openModal: false,
            fetching: false,
            ready: false,
            business: {},
            submittingForm: false,
            selectedMonth: false,
            monthsList: [],
            sales: [],
            totalSales: [],
            accumulated: [],
            report: [],
            summery: [],

            requestingWithdraw: false,
            canSendWithdrawalRequest: true,

        };

        this.onSubmit = this.onSubmit.bind(this);
        this.init = this.init.bind(this);
        this.createMarkup = this.createMarkup.bind(this);
        this.renderMonthDetails = this.renderMonthDetails.bind(this);
        this.renderOrders = this.renderOrders.bind(this);

        this.renderReport = this.renderReport.bind(this);
        this.sendWithdrawalRequest = this.sendWithdrawalRequest.bind(this);
        this.toggleMonthModal = this.toggleMonthModal.bind(this);
    }

    componentDidMount() {
        this.init();
    }

    toggleMonthModal() {
        this.setState({openModal: !this.state.openModal});
    }


    init() {
        this.setState({
            fetching: true
        }, () => {
            const data = {};
            axios.post(`${Config.api()}financial/account-summary/init/${this.props.auth.business.id}`, data, {
                withCredentials: Config.withCredentials()
            }).then((response) => {
                if (response.data.status) {
                    this.setState({
                        fetching: false,
                        ready: true,
                        business: response.data.business,
                        monthsList: response.data.months,
                        totalSales: response.data.total_sales,
                        report: response.data.report,
                        summery: response.data.summery,
                        accumulated: response.data.accumulated,
                    });
                } else {
                    NotificationManager.error(locale.get('an_error_occurred_while_initializing_data'));
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.props.requiresReLogin();
                } else {
                    NotificationManager.error(locale.get('an_error_occurred_while_initializing_data'));
                }
            });
        });
    }

    sendWithdrawalRequest(data) {
        this.setState({
            requestingWithdraw: true
        }, () => {

            axios.post(`${Config.api()}financial/account-summary/withdrawal-request/${this.props.auth.business.id}/${data['month']}`, data, {
                withCredentials: Config.withCredentials()
            }).then((response) => {

                if (response.data.status) {
                    NotificationManager.success(response.data.message);
                    this.setState({
                        requestingWithdraw: false,
                        canSendWithdrawalRequest: false,
                    }, () => {
                        this.init();
                        // setTimeout(()=>{
                        //     window.location.reload();
                        // },1500);
                    });
                } else {
                    this.setState({
                        requestingWithdraw: false,
                        canSendWithdrawalRequest: true,
                    }, () => {
                        console.log(this.state)
                    });
                    NotificationManager.error(<span
                        dangerouslySetInnerHTML={this.createMarkup(response.data.message)}/>);
                }

            }).catch((error) => {
                this.setState({
                    requestingWithdraw: false,
                    canSendWithdrawalRequest: true,
                });

                if (error.response.status === 401) {
                    this.props.requiresReLogin();
                } else {
                    NotificationManager.error(locale.get('an_error_occurred_while_initializing_data'));
                }
            });
        });

    }

    onSubmit(values) {
        const errors = validateAccountSummary(values, this.props);
        if (Object.keys(errors).length > 0) {
            NotificationManager.error(locale.get('please_fill_all_required_fields'));
            return false;
        }
        this.setState({
            submittingForm: true,
            selectedMonth: values.month,
            sales: [],
        }, () => {

            axios.post(`${Config.api()}financial/account-summary/month-sales/${this.props.auth.business.id}`, values, {
                withCredentials: Config.withCredentials()
            }).then((response) => {
                this.setState({
                    submittingForm: false,
                    sales: response.data.sales ? response.data.sales : [],
                });
                if (response.data.status === true) {

                } else {
                    NotificationManager.error(locale.get('an_error_occurred_while_saving_your_bank_details'));
                }
            }).catch((error) => {
                this.setState({
                    submittingForm: false,
                    sales: [],
                });
                console.log('error', error)
                if (error.response.status === 401) {
                    this.props.requiresReLogin();
                } else {
                    NotificationManager.error(locale.get('an_error_occurred_while_saving_your_bank_details'));
                }
            });
        });
    }

    createMarkup(string) {
        return {__html: string};
    }

    render() {
        return (
            this.state.fetching && !this.state.ready ? <Loader completed={this.state.ready}/> : <div>

                <FinancialBankDetailsPopUp businessSlug={this.props.auth.business.slug}
                                           isOpen={this.state.business['shouldFillBankDetails']}/>

                <div className="panel-1">
                    <div className="panel-1--head bg-white">
                        {locale.get('financial_total_balance')}
                    </div>
                    <div className="panel-1--body is-full">
                        {this.renderReport()}
                    </div>

                </div>


                {this.renderMonthDetails()}

            </div>

        )
    }

    formatPrice(price, className) {
        const _formattedNumber = new Intl.NumberFormat("en", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(price);

        return <span className={`price ${className ? className : ''}`}>
            <span className="amount">{_formattedNumber}</span>
            <span className="notranslate symbol">₪</span>
            <span className="currency">{locale.get('system_currency')}</span>
        </span>
    }

    renderReport(items = []) {
        return (
            this.state.accumulated.length > 0 || 1 === 1 && <div>

                <table className="table mb-30">
                    <thead>
                    <tr>
                        <th width="150px">{locale.get('total_sales')}</th>
                        <th width="150px">{locale.get('total_sales_shipped_by_seller')}</th>
                        <th width="150px">{locale.get('setup_fees')}</th>
                        <th width="150px">{locale.get('lazmak_commission')}</th>
                        <th width="150px">{locale.get('net_sales')}</th>
                        <th width="150px">{locale.get('credit')}</th>
                        <th width="150px">{locale.get('debit')}</th>
                        <th width="150px">{locale.get('balance')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>{FormattedPrice(this.state.summery.total_sales, this.state.summery.total_sales < 0 ? 'negative' : '')}</td>
                        <td>{FormattedPrice(this.state.summery.shipped_by_seller_total, this.state.summery.shipped_by_seller_total < 0 ? 'negative' : '')}</td>
                        <td>{FormattedPrice(this.state.summery.seller_shipping_fees, this.state.summery.seller_shipping_fees < 0 ? 'negative' : '')}</td>
                        <td>{FormattedPrice(this.state.summery.shooq_total, this.state.summery.shooq_total < 0 ? 'negative' : '')}</td>
                        <td>{FormattedPrice(this.state.summery.seller_amount, this.state.summery.seller_amount < 0 ? 'negative' : '')}</td>
                        <td>{FormattedPrice(this.state.summery.total_credit, this.state.summery.total_credit < 0 ? 'negative' : '')}</td>
                        <td>{FormattedPrice(this.state.summery.total_debit, this.state.summery.total_debit < 0 ? 'negative' : '')}</td>

                        <td>{FormattedPrice(this.state.summery.balance, `badge ${this.state.summery.balance < 0 ? 'badge--4' : 'badge--1'}`)}</td>

                    </tr>
                    </tbody>
                </table>

                {
                    this.state.report.length === 0 ? '' : <table className="table ">
                        <thead>
                        <tr>
                            <th width={1}>{locale.get('month')}</th>
                            <th>{locale.get('total_sales')}</th>
                            <th>{locale.get('total_sales_shipped_by_seller')}</th>
                            <th>{locale.get('setup_fees')}</th>
                            <th>{locale.get('lazmak_commission')}</th>
                            <th>{locale.get('net_sales')}</th>
                            <th>{locale.get('credit')}</th>
                            <th>{locale.get('debit')}</th>
                            <th>{locale.get('balance')}</th>
                            <th>
                                <button type="button" className="btn btn-1 btn--small"
                                        onClick={this.toggleMonthModal}>{locale.get('details')}</button>
                            </th>
                        </tr>
                        </thead>
                        {this.state.report.map((businessDetails, index) => {
                            return <tbody key={`business-details-${index}`}>
                            {
                                Object.keys(businessDetails['monthly_sales']).map((monthKey, monthIndex) => {
                                    const monthDetails = businessDetails['monthly_sales'][monthKey];
                                    return <tr key={`month-details-${monthIndex}`}>
                                        <td>{monthDetails['short_date']}</td>
                                        <td>{FormattedPrice(monthDetails['total_sales'])}</td>
                                        <td>{FormattedPrice(monthDetails['shipped_by_seller_total'])}</td>
                                        <td>{FormattedPrice(monthDetails['seller_shipping_fees'])}</td>
                                        <td>{FormattedPrice(monthDetails['shooq_total'])}</td>
                                        <td>{FormattedPrice(monthDetails['seller_amount'])}</td>
                                        <td>{FormattedPrice(monthDetails['total_credit'])}</td>
                                        <td>{FormattedPrice(monthDetails['total_debit'])}</td>
                                        <td>{FormattedPrice(monthDetails['balance'], `badge ${monthDetails['balance'] < 0 ? 'badge--4' : 'badge--1'}`)}</td>
                                        <td>
                                            {
                                                monthDetails['can_withdraw'] === false ? <span>---</span> : (
                                                    monthDetails['can_send_withdrawal_requests'] === false ?
                                                        <span className="badge badge--6">
                                                        {
                                                            monthDetails['withdrawal_request_status'] || '---'
                                                        }
                                                    </span> : <span>
                                                    <button
                                                        type="button"
                                                        className="btn btn-2 btn--small"
                                                        disabled={this.state.requestingWithdraw}
                                                        onClick={(e) => {
                                                            this.sendWithdrawalRequest({
                                                                business_id: businessDetails['business']['id'],
                                                                month: monthDetails['short_date'],
                                                                balance: monthDetails['balance'],
                                                            })
                                                        }}
                                                    >
                                                    <Loader completed={this.state.requestingWithdraw === false}/>
                                                        {locale.get('withdraw_request')}
                                                    </button>

                                            </span>
                                                )
                                            }
                                        </td>

                                    </tr>
                                })
                            }
                            <tr>
                                <td className="cell--gray no-hover">{locale.get('total')}</td>
                                <td className="cell--gray no-hover">{FormattedPrice(businessDetails['summery']['total_sales'])}</td>
                                <td className="cell--gray no-hover">{FormattedPrice(businessDetails['summery']['shipped_by_seller_total'])}</td>
                                <td className="cell--gray no-hover">{FormattedPrice(businessDetails['summery']['seller_shipping_fees'])}</td>
                                <td className="cell--gray no-hover">{FormattedPrice(businessDetails['summery']['shooq_total'])}</td>
                                <td className="cell--gray no-hover">{FormattedPrice(businessDetails['summery']['seller_amount'])}</td>
                                <td className="cell--gray no-hover">{FormattedPrice(businessDetails['summery']['total_credit'])}</td>
                                <td className="cell--gray no-hover">{FormattedPrice(businessDetails['summery']['total_debit'])}</td>
                                <td className="cell--gray no-hover">{FormattedPrice(businessDetails['summery']['balance'], `badge ${businessDetails['summery']['balance'] < 0 ? 'badge--4' : 'badge--1'}`)}</td>
                                <td className="cell--gray no-hover"/>
                            </tr>

                            </tbody>;
                        })}
                    </table>

                }
            </div>
        )
    }

    renderMonthDetails() {
        return (
            <div>
                {this.state.openModal ? (
                    <ShooqModal showModal={this.state.openModal}
                                 className="shooq-modal--large"
                                 onRequestClose={this.toggleMonthModal}
                                 modalTitle={locale.get('financial_month_summary')}
                                 modalSubTitle={''}>

                        <div className="panel-1">
                            <div className="panel-1--head bg-white">
                                {locale.get('financial_month_summary')}
                            </div>
                            <div className="panel-1--body is-full">
                                <form className="form-horizontal" onSubmit={this.props.handleSubmit(this.onSubmit) }>
                                    <Field
                                        name="month"
                                        id="month"
                                        component={ProductInput}
                                        className="form-control"
                                        label={locale.get('select_month')}
                                        placeholder={locale.get('select_month')}
                                        field={{
                                            is_required: true,
                                            data_type: "dropdown",
                                            options: this.state.monthsList
                                        }}/>

                                    <button className="btn btn-1" disabled={this.state.submittingForm}><Loader
                                        completed={this.state.submittingForm === false}/> {locale.get('submit')}
                                    </button>

                                </form>
                            </div>
                        </div>
                        {
                            this.state.sales.length === 0 ? '' : <div>
                                <div className="panel-1">
                                    <div className="panel-1--head bg-white">
                                        {locale.get('orders')}
                                    </div>
                                    <div className="is-full">
                                        {this.renderOrders()}
                                    </div>
                                </div>
                            </div>
                        }
                    </ShooqModal>) : ('')}

            </div>
        )
    }

    renderOrders() {
        const items = this.state.sales;
        return (
            items.length > 0 && <div>
                {
                    items.map((businessData, index) => {
                        console.log(businessData)
                        return Object.keys(businessData['monthly_sales']).map((monthKey, index) => {
                            const monthDetails = businessData['monthly_sales'][monthKey];
                            return <div key={`month-${monthKey}`}>
                                <table className="table mb-30">
                                    <thead>
                                    <tr>
                                        <th width={1}>{locale.get('month')}</th>
                                        <th>{locale.get('total_sales')}</th>
                                        <th>{locale.get('total_sales_shipped_by_seller')}</th>
                                        <th>{locale.get('setup_fees')}</th>
                                        <th>{locale.get('lazmak_commission')}</th>
                                        <th>{locale.get('net_sales')}</th>
                                        <th>{locale.get('credit')}</th>
                                        <th>{locale.get('debit')}</th>
                                        <th>{locale.get('balance')}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>{monthDetails['short_date']}</td>
                                        <td>{FormattedPrice(monthDetails['total_sales'])}</td>
                                        <td>{FormattedPrice(monthDetails['shipped_by_seller_total'])}</td>
                                        <td>{FormattedPrice(monthDetails['seller_shipping_fees'])}</td>
                                        <td>{FormattedPrice(monthDetails['shooq_total'])}</td>
                                        <td>{FormattedPrice(monthDetails['seller_amount'])}</td>
                                        <td>{FormattedPrice(monthDetails['total_credit'])}</td>
                                        <td>{FormattedPrice(monthDetails['total_debit'])}</td>
                                        <td>{FormattedPrice(monthDetails['balance'], `badge ${monthDetails['balance'] < 0 ? 'badge--4' : 'badge--1'}`)}</td>
                                    </tr>

                                    </tbody>
                                </table>

                                {
                                    monthDetails['orders'].map((order, orderIndex) => {
                                        return <div key={`order-${monthKey}-${orderIndex}`} className="mb-30">
                                            <table className="table">
                                                <thead>
                                                <tr>
                                                    <th className="cell--gray no-hover" width={10}>Order
                                                        #{order['id']}</th>
                                                    <th className="cell--gray no-hover">{locale.get('product_name')}</th>
                                                    <th className="cell--gray no-hover"
                                                        width={200}>{locale.get('quantity')}</th>
                                                    <th className="cell--gray no-hover"
                                                        width={200}>{locale.get('price')}</th>
                                                    <th className="cell--gray no-hover"
                                                        width={200}>{locale.get('is_replaced_item')}</th>

                                                    <th className="cell--gray no-hover"
                                                        width={200}>{locale.get('setup_fees')}</th>
                                                    <th className="cell--gray no-hover"
                                                        width={200}>{locale.get('sub_total')}</th>
                                                    {/*<th width={100}>Total</th>*/}
                                                </tr>
                                                </thead>

                                                <tbody>
                                                {
                                                    order['items'].map((item, index) => {
                                                        return <tr key={`order-item-${index}`}>
                                                            <td>{item['id']}</td>
                                                            <td>{item['product_name']}</td>
                                                            <td>{item['quantity']}</td>
                                                            <td>{item['price']}</td>
                                                            <td>{parseInt(item['replacement'], 10) === 1 ? locale.get('yes') : locale.get('no') }</td>
                                                            <td>{item['seller_shipping_fees']}</td>
                                                            <td>{item['sub_total']}</td>
                                                        </tr>
                                                    })
                                                }
                                                </tbody>
                                                <tfoot>
                                                <tr>
                                                    <td>{locale.get('total')}</td>
                                                    <td colSpan={4}/>
                                                    <td>{order['seller_shipping_fees']}</td>
                                                    <td>{order['sub_total']}</td>
                                                </tr>

                                                </tfoot>
                                            </table>
                                            <table className="table">
                                                <tbody>
                                                <tr>
                                                    {/*<td>Total</td>*/}
                                                    {/*<td colSpan={4}/>*/}
                                                    {/*<td width={200}>{businessData['monthly_sales']['orders'][key]['seller_shipping_fees']}</td>*/}
                                                    {/*<td width={200}>{businessData['monthly_sales']['orders'][key]['seller_shipping_fees']}</td>*/}
                                                    {/*<td width={200}>{businessData['monthly_sales']['orders'][key]['sub_total']}</td>*/}
                                                </tr>
                                                </tbody>
                                            </table>

                                        </div>

                                    })

                                }
                            </div>
                        });
                    })

                }
            </div>
        )
    }
}


// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth
    }
};


// Maps actions to props
const mapDispatchToProps = (dispatch) => ({});
const validateAccountSummary = (values, props) => {
    let errors = {};
    if (!values.month || isEmpty(trim(values.month))) {
        errors.month = locale.get('required');
    }

    errors = {...errors}
    return errors;
};


AccountSummary = reduxForm({
    form: 'AccountSummary',
    enableReinitialize: true,
    validate: validateAccountSummary,
})(AccountSummary);

export default connect(mapStateToProps, mapDispatchToProps)(AccountSummary);
